import { initContract } from '@ts-rest/core'
import z from 'zod'

const c = initContract()

export const cartHealthContract = c.router({
  getHealth: {
    method: 'GET',
    path: '/health',
    summary: 'Health check endpoint',
    description: 'Checks if the service is healthy',
    responses: {
      200: z.object({
        status: z.string(),
      }),
    },
  },
})
